import { SmsTemplate } from 'app/models/dto/sms-template.model';

export class GetSmsTemplates {
	static readonly type = '[SmsTemplates] GetSmsTemplates';
	constructor() {}
}
export class CreateSmsTemplate {
	static readonly type = '[SmsTemplates] CreateSmsTemplate';
	constructor(public template: { title: string, content: string }) {}
}
export class UpdateSmsTemplate {
	static readonly type = '[SmsTemplates] UpdateSmsTemplate';
	constructor(public template: SmsTemplate) {}
}

export class GetTemplateVariables {
	static readonly type = '[SmsTemplates] GetTemplateVariables';
	constructor() {}
}

export class DeleteSmsTemplate {
	static readonly type = '[SmsTemplates] DeleteSmsTemplate';
	constructor(public templateId: number) {}
}
